import ScreensPage from "./screens";

function Home() {
  return <ScreensPage />;
  // return (
  //   <div>
  //     <CustomHead title="Signage Studio" />

  //     <DashBoard />
  //   </div>
  // );
}
export default Home;
